import { VesselIcon } from '../VesselIcon';
import { getDiffInMinutes } from '../../helpers';
import moment from 'moment/moment';
import { OwnedTargetInfo } from 'ais-facade-api/api';
import styles from './VesselProgressBar.module.scss';

interface Props {
  eta?: string;
  vessel?: OwnedTargetInfo;
  departureTime?: string;
  empty?: boolean;
}

export const VesselProgressBar = ({ empty = false, vessel, departureTime, eta }: Props) => {
  const now = moment.utc().format('DD.MM.YYYY \u2013 HH:mm');
  // Вычисление общего интервала времени между датой отправления и предполагаемой датой прибытия
  const totalTime = getDiffInMinutes(eta, departureTime);
  // Вычисление интервала времени между текущей датой и датой отправления
  const elapsedTime = getDiffInMinutes(now, departureTime);
  const completed = elapsedTime && totalTime ? (elapsedTime / totalTime) * 100 : null;
  if (empty) {
    return <div className={styles.container_empty}></div>;
  }
  return (
    <div className={styles.container}>
      <div className={styles.progress} style={{ width: `${completed}%` }}>
        <span className={styles.vesselIcon}>
          <VesselIcon vessel={vessel} inProgressBar />
        </span>
      </div>
    </div>
  );
};
